import * as React from 'react';
import { reduxForm } from 'redux-form';
import ViewEditForm, { ViewEditFormProps } from '../../shared/Forms/ViewEditForm/ViewEditForm';
import { decimal, nonNegative, required } from '../../shared/Forms/validations';
import { debtTypeMap } from '../../AddDebt/AddDebtForm/debtTypes';

const DebtDetailsForm = (props: ViewEditFormProps) => (
  <ViewEditForm
    {...props}
    fieldData={[
      {
        name: 'currentBalance',
        type: 'number',
        label: 'Current Balance',
        fieldFormat: 'dollar',
        validate: [required, decimal]
      },
      {
        name: 'minimumPayment',
        type: 'number',
        label: 'Min. Payment Due',
        fieldFormat: 'dollar',
        validate: [decimal]
      },
      {
        name: 'percentBalanceChange',
        type: 'number',
        fieldFormat: 'percentage',
        label: '% Paid Off',
        validate: []
      },
      {
        name: 'type',
        options: debtTypeMap,
        type: 'select',
        label: 'Type',
        validate: [required]
      },
      {
        name: 'apr',
        type: 'number',
        fieldFormat: 'percentage',
        label: 'APR %',
        validate: [nonNegative]
      }
    ]}
  />
);

export default reduxForm({
  form: 'debtDetailsForm'
})(DebtDetailsForm);
